import { posthog } from '@/app-shell/flags/posthog-compat';

export const IS_AUTO_MODE_ONLY_ENABLED = () => {
  return posthog.isFeatureEnabled('release-auto-mode-only');
};
